import { render, staticRenderFns } from "./NewWorkerForm.vue?vue&type=template&id=c3b66e2a&"
import script from "./NewWorkerForm.vue?vue&type=script&lang=js&"
export * from "./NewWorkerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports